export const IDENTITY_AUTHORITY = process.env.REACT_APP_AUTHORITY;
export const IDENTITY_CLIENT_ID = process.env.REACT_APP_IDENTITY_CLIENT_ID;
export const IDENTITY_SCOPE = process.env.REACT_APP_IDENTITY_SCOPE;
export const IDENTITY_REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI;
export const IDENTITY_LOGOUT_REDIRECT_URI = process.env.REACT_APP_LOGOUT_REDIRECT_URI;
export const IDENTITY_SILENT_REDIRECT_URI = process.env.REACT_APP_SILENT_REDIRECT_URI;
// eslint-disable-next-line max-len
export const IDENTITY_ACCESS_TOKEN_EXPIRING_NOTIFICATION_TIME = 60 * 2; // 2 minutos antes de expirar
export const IDENTITY_NECESSARY_ROLES = ['Epimed Data Audit', 'SuperAdministrator', 'Administrator'];
